import React, { useContext, useEffect, useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";

import { MatchContext } from "../../context";
import { RADIO_SWITCHER_VALUES } from "../../constants";

export default function InputOutputSwitcher({ handleSwitch }): JSX.Element {
  const { state } = useContext(MatchContext);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (state.stockpiles) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [state.stockpiles]);

  return (
    <FormControl component="fieldset">
      <RadioGroup
        row
        aria-label="position"
        name="position"
        defaultValue={state.ioSwitcherValue}
        value={state.ioSwitcherValue}
        onChange={(e) => handleSwitch(e.target.value)}
      >
        <FormControlLabel
          value={RADIO_SWITCHER_VALUES.INPUT}
          control={<Radio color="primary" />}
          label={RADIO_SWITCHER_VALUES.INPUT}
        />
        <FormControlLabel
          value={RADIO_SWITCHER_VALUES.OUTPUT}
          control={<Radio color="primary" />}
          label={RADIO_SWITCHER_VALUES.OUTPUT}
        />
        <FormControlLabel
          value={RADIO_SWITCHER_VALUES.EQUIPMENT}
          control={<Radio color="primary" />}
          label={RADIO_SWITCHER_VALUES.EQUIPMENT}
          disabled={disabled}
        />
      </RadioGroup>
    </FormControl>
  );
}
